(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["typhur-collection-gallery"] && !Shopify.designMode) return;
  try {
    const changeActiveTab = (e) => {
    e.preventDefault()

    //find the active tab and the open tab panel
    let activeTab = e.currentTarget.parentNode.parentNode.querySelector('[role="tabpanel"][open]')
    let activeTabLabel = e.currentTarget.parentNode.querySelector('[aria-selected="true"]')

    //deactivate both
    activeTab.removeAttribute("open")
    activeTabLabel.setAttribute("aria-selected", false)

    //get tabpanel associated with clicked tab, activate both
    const tab = e.currentTarget.parentNode.parentNode.querySelector(e.currentTarget.getAttribute("href"))
    tab.setAttribute("open","")
    e.currentTarget.setAttribute("aria-selected", true)
    
    //get new active tab and new active label, then adjust menu height
    activeTab = tab
    activeTabLabel = e.currentTarget

    const p = activeTab.closest("[ref='submenu[]']")
    const submenuHeight = activeTab.closest('[ref="submenu[]"]').offsetHeight

    activeTab.closest("#header-component").style.setProperty("--submenu-height", `${submenuHeight}px`)
    const a = activeTab.closest("header-menu")
    activeTab.closest("header-menu").publicSetFullOpenHeaderHeight(submenuHeight)
  }

  Array.from(document.querySelectorAll('[id^="typhur-collection-gallery-tab-"]')).forEach(node => {
    node.addEventListener('click', changeActiveTab)
  })
  } catch(e) { console.error(e); }
})();

})();
